module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/banner/en-8a9f6f5fc68a1d8343df0dade1c53be5.jpg";